import { styled } from '@mui/material';

export interface PasswordStrengthBarProps {
  active: boolean;
  color: string;
}

export const PasswordStrengthBar = styled('div', {
  shouldForwardProp: (prop) => prop !== 'active' && prop !== 'color',
})<PasswordStrengthBarProps>(({ theme, active, color }) => ({
  flex: 1,
  maxWidth: `calc(33% - ${theme.spacing(3)})`,
  height: 7,
  borderRadius: theme.spacing(10),
  backgroundColor: active ? color : theme.palette.secondary[200],
}));
